import Api from './ApiService'

export default {
    get(keyword, pageNumber, sort) {
        return Api().get(`autor?keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}`);
    },
    getOne(id) {
        return Api().get(`autor/${id}`);
    },
    create(data) {
        return Api().post(`autor`, data);
    },
    update(data) {
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        return Api().put(`autor/${data.id}`, data.data, config);
    }
}